import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CountryHouseBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.COUNTRY_HOUSE;
}

export default CountryHouseBuildingTileEntity;
